import { useEffect, useState } from "react";
import Image from "next/image";
import styles from "@/components/ui/pagination/PaginationComponent.module.css";
import FirstPageSvg from "/public/icons/angle-double-left.svg";
import PrevPageSvg from "/public/icons/angle-left.svg";
import NextPageSvg from "/public/icons/angle-right.svg";
import LastPageSvg from "/public/icons/angle-double-right.svg";

function PaginationComponent({
  onPageChange,
  total,
  page: currentPage,
  setPage,
}) {
  const [pager, setPager] = useState([]);

  const pagesToShow = 5;
  const pagesOffset = Math.floor(pagesToShow / 2);

  useEffect(() => {
    const startPage = Math.max(1, currentPage - pagesOffset);
    const endPage = Math.min(total, currentPage + pagesOffset);
    const pager = [];

    if (currentPage > 1) {
      pager.push({ type: "<<", component: FirstPageSvg });
      pager.push({ type: "<", component: PrevPageSvg });
    }

    for (let i = startPage; i <= endPage; i++) {
      pager.push(i);
    }

    if (currentPage < total) {
      pager.push({ type: ">", component: NextPageSvg });
      pager.push({ type: ">>", component: LastPageSvg });
    }

    setPager(pager);
  }, [currentPage, total]);

  const handlePageChange = (page) => {
    let newPage;

    if (typeof page === "object") {
      if (page.type === "<<") newPage = 1;
      else if (page.type === "<") newPage = Math.max(1, currentPage - 1);
      else if (page.type === ">") newPage = Math.min(total, currentPage + 1);
      else if (page.type === ">>") newPage = total;
    } else newPage = parseInt(page);

    newPage = Math.min(newPage, total);

    onPageChange(newPage);
  };

  return (
    <div className={styles.paginationContainer}>
      {pager.map((page, index) => (
        <div
          className={`${styles.paginationItem} ${
            page === currentPage ? styles.activeItem : ""
          }`}
          key={index}
          onClick={() => handlePageChange(page)}>
          {typeof page === "object" && (
            <Image
              src={page.component}
              alt={page.type}
              width={12}
              height={12}
            />
          )}
          {typeof page === "number" && page}
        </div>
      ))}
    </div>
  );
}

export default PaginationComponent;
